"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = exports.ErrorMessages = void 0;
exports.ErrorMessages = {
    socketResponseError: "Oops! Something went wrong, try again later!",
    unauthorizedUser: "User not authorized",
    loginError: "Login failed",
    sessionExpiry: "Your session is expired. Please login again.",
    genericError: "Oops! Something went wrong, try again later!",
    noAccessFound: "You do not have access for this feature",
};
exports.ErrorCodes = {
    GROUP_ALREADY_EXIST_WITH_SAME_DOB: "GROUP_ALREADY_EXIST_WITH_SAME_DOB",
    GROUP_ALREADY_EXIST: "GROUP_ALREADY_EXIST",
};
